import React from 'react';
import { tierBackgroundStyle, tierCrownStyle, tierParentOpacityStyle, tierParentStyle } from '../../style.vs.css';
import type { LoyaltyTierIconProps } from '../..';

export const DiamondMD = ({ behavior }: Pick<LoyaltyTierIconProps, 'behavior'>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        className={behavior === 'changeOpacityOnHover' ? tierParentOpacityStyle : tierParentStyle}
    >
        <path
            d="M10.7727 1.10847C11.5322 0.670006 12.4678 0.670006 13.2273 1.10847L21.165 5.69134C21.9245 6.1298 22.3923 6.94011 22.3923 7.81703V16.9828C22.3923 17.8597 21.9245 18.67 21.165 19.1085L13.2273 23.6913C12.4678 24.1298 11.5322 24.1298 10.7727 23.6913L2.83497 19.1085C2.07553 18.67 1.6077 17.8597 1.6077 16.9828V7.81703C1.6077 6.94011 2.07553 6.1298 2.83497 5.69134L10.7727 1.10847Z"
            fill="url(#paint0_linear_1934_151798)"
            {...(behavior === 'showColorOnHover' ? { className: tierBackgroundStyle } : {})}
        />
        <path
            d="M15.9106 10.2844C15.9457 10.0127 15.6458 9.82505 15.4168 9.97551L14.096 10.8435C14.0408 10.8797 13.9674 10.8702 13.9233 10.8211L12.2385 8.94374C12.1112 8.80184 11.8888 8.80184 11.7615 8.94374L10.0767 10.8211C10.0326 10.8702 9.9592 10.8797 9.90401 10.8435L8.5832 9.97551C8.35424 9.82505 8.05429 10.0127 8.08938 10.2844L8.65564 14.6693C8.67284 14.8025 8.78623 14.9022 8.9205 14.9022H15.0795C15.2138 14.9022 15.3272 14.8025 15.3444 14.6693L15.9106 10.2844Z"
            fill="url(#paint1_linear_1934_151798)"
            {...(behavior === 'showColorOnHover' ? { className: tierCrownStyle } : {})}
        />
        <defs>
            <linearGradient
                id="paint0_linear_1934_151798"
                x1="12"
                y1="0.399902"
                x2="12"
                y2="24.3999"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#496BA2" />
                <stop offset="1" stopColor="#1F3056" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1934_151798"
                x1="12"
                y1="8.67798"
                x2="12"
                y2="14.9022"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#B9CDED" />
                <stop offset="1" stopColor="#5875A3" />
            </linearGradient>
        </defs>
    </svg>
);
